@if (show) {
<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content large" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-heading">
        <h2>{{ 'INTERACTIONS.MANAGE_FILES_MODAL.TITLE' | translate }}</h2>
        <p class="modal-subtitle">{{ 'INTERACTIONS.MANAGE_FILES_MODAL.SUBTITLE' | translate }}</p>
      </div>
      <button type="button" class="modal-close-btn" (click)="onClose()" [title]="'BUTTON.CLOSE' | translate">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-actions">
      <button class="upload-btn" (click)="onAddArchive()">
        <fa-icon [icon]="faPlus" class="btn-icon"></fa-icon>
        {{ 'BUTTON.UPLOAD' | translate }}
      </button>
      @if (hasSelectedArchives) {
      <button class="save-btn" [disabled]="!hasSelectedArchives" (click)="addSelectedArchivesToInteraction()">
        <fa-icon [icon]="faSave" class="btn-icon"></fa-icon>
        {{ 'BUTTON.SAVE' | translate }}
      </button>
      }
    </div>

    <div class="existing-archives-section">
      <div class="archives-list-header">
        <app-search [config]="searchConfig"
          [initialFilters]="{ searchTerm: searchTerm, selectedTag: selectedTag }"
          (filtersChanged)="onFiltersChanged($event)"></app-search>

        <div class="selection-info inline">
          <label class="select-all-label">
            <input type="checkbox" [checked]="isAllFilteredSelected()" [indeterminate]="isSomeFilteredSelected()"
              (change)="toggleSelectAllFiltered($event.target.checked)" [disabled]="filteredArchives.length === 0" />
            <span class="select-all-text">
              {{ 'INTERACTIONS.MANAGE_FILES_MODAL.SELECT_ALL' | translate }}
            </span>
            <span class="selected-count">
              {{ selectedArchivesCount }} {{ 'ARCHIVES.SELECTED' | translate }}
            </span>
          </label>
          @if (isAtMaxArchives) {
          <span class="max-archives-warning">
            {{ 'INTERACTIONS.MANAGE_FILES_MODAL.MAX_ARCHIVES_WARNING' | translate: { max: MAX_ARCHIVES } }}
          </span>
          }
        </div>
      </div>


      <app-item-list [items]="filteredArchives" [config]="listConfig" [loading]="isLoading"
        [hasActiveFilters]="!!searchTerm || !!selectedTag" [selectedItems]="selectedArchives"
        (itemSelectionChanged)="onItemSelectionChanged($event)"></app-item-list>

      <div class="pagination-wrapper" *ngIf="totalPages > 1">
        <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" [totalItems]="totalArchives"
          [pageSize]="pageSize" (pageChange)="onPageChange($event)">
        </app-pagination>
      </div>
    </div>
  </div>
</div>
}

<app-modal-upload-archives [show]="showUploadModal" (close)="closeUploadModal()"
  (uploadSuccess)="onUploadSuccess($event)">
</app-modal-upload-archives>
